// src/main.jsx
// -----------------------------------------------------------------------------
// Application entry point. Mounts <App /> into the #root div from index.html,
// wrapped with the Router and the global AuthProvider context.
// -----------------------------------------------------------------------------
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import App from './App.jsx';
import { AuthProvider } from './context/AuthContext.jsx';
import { LoadingProvider } from './context/LoadingContext.jsx';
import { NotificationProvider } from './context/NotificationContext.jsx';
import GlobalLoader from './components/common/GlobalLoader.jsx';

// Global styles - theme.css defines the AFix color palette (from the logo),
// layout.css styles the sidebar/header/footer shell.
import './styles/theme.css';
import './styles/layout.css';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <LoadingProvider>
        <AuthProvider>
          <NotificationProvider>
            <App />
            <GlobalLoader />
            {/* Global toast notifications (success/error messages from API calls) */}
            <ToastContainer position="top-right" autoClose={3000} />
          </NotificationProvider>
        </AuthProvider>
      </LoadingProvider>
    </BrowserRouter>
  </React.StrictMode>
);